export default "__VITE_ASSET__BCcwBuw6__"